import type { IShiftPlanDoc } from "../../typings"
import {
  CreateShiftPlanButton,
  ShiftPlanBody,
} from "../../overview/ConfigurationWorkplace"
import ConfigurationCard, {
  ConfigurationCardPropsCardStatus,
} from "../../components/ConfigurationCard"
import { formatDateReadable } from "utils/formatDate"
import { UseMutateFunction } from "@tanstack/react-query"
import { AxiosResponse } from "axios"
import CustomEmptyState from "../../overview/component/CustomEmptyState"
import { Dispatch, SetStateAction } from "react"

export function formatDateRange(isoDate: string): string {
  try {
    const d = new Date(isoDate)
    return d.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })
  } catch {
    return "—"
  }
}

interface RosteredPlansProps {
  plans?: IShiftPlanDoc[] | undefined
  archiveShiftPlan?: UseMutateFunction<
    AxiosResponse<any, any>,
    any,
    { id: number; body: ShiftPlanBody },
    unknown
  >
  onRestorePlan?: (planId: number) => void
  onEditPlan?: (plan: IShiftPlanDoc) => void
  createShift?: Dispatch<SetStateAction<boolean>>
  goToCreateFlow?: () => void
  toggleShiftPlan?: UseMutateFunction<
    AxiosResponse<any, any>,
    any,
    { id: number; body: ShiftPlanBody },
    unknown
  >
}

const RosteredPlans: React.FC<RosteredPlansProps> = ({
  plans,
  archiveShiftPlan,
  onRestorePlan,
  onEditPlan,
  goToCreateFlow,
  toggleShiftPlan,
  createShift,
}) => {
  return (
    <>
      {plans?.length === 0 ? (
        <CustomEmptyState
          imageUrl="https://padehrs3-staging.s3.us-east-2.amazonaws.com/images/97c81704-a27c-4cfd-92b9-001c60cb71db.png"
          onClick={() => createShift!(true)}
          title="Create shift plan"
        />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-2">
          {plans?.map((plan) => (
            <ConfigurationCard
              key={plan.id}
              date={`${formatDateReadable(plan.createdDate)} `}
              title={plan.title}
              employeeCount={plan.totalEmployees || 0}
              shiftCount={plan.totalShiftPeriods || 0}
              status={
                plan.isDeleted
                  ? plan.isDeleted
                  : (plan.status as ConfigurationCardPropsCardStatus)
              }
              onEdit={() => onEditPlan!(plan)}
              onRestore={() => onRestorePlan!(plan.id)}
              onArchive={() =>
                archiveShiftPlan!({
                  id: plan.id,
                  body: { isDeleted: true },
                })
              }
              onToggle={() =>
                plan.status === "published"
                  ? toggleShiftPlan!({
                      id: plan.id,
                      body: { isActive: false, status: "draft" },
                    })
                  : toggleShiftPlan!({
                      id: plan.id,
                      body: { isActive: true, status: "published" },
                    })
              }
            />
          ))}
          <CreateShiftPlanButton handleNavigateCreate={goToCreateFlow!} />
        </div>
      )}
    </>
  )
}

export default RosteredPlans
